module.exports = __webpack_public_path__ + "img/dropdown-icon.1ea75cbd.svg";